import { render, staticRenderFns } from "./app-monitor.vue?vue&type=template&id=a825f300"
import script from "./app-monitor.vue?vue&type=script&lang=js"
export * from "./app-monitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports